import {Action} from '@ngrx/store';
import {RolleBenutzerCheckboxWrapper} from './dokument-verwaltung.reducer';
import {Dokument} from '../../../../clients/vorlagen';

export const PAGE_STATE_RESET = '[DokumentverwaltungPage] Page State reset';

// UI
export const NEUES_DOKUMENT = '[DokumentverwaltungPage] Neues Dokument (Felder leeren)';
export const DOKUMENT_ABBRECHEN = '[DokumentverwaltungPage] Dokument abbrechen (Felder leeren)';
export const AKTUELLES_DOKUMENT_GESETZT = '[DokumentverwaltungPage] Aktuelles Dokument gesetzt';
export const AKTUELLES_DOKUMENT_WURDE_GELOESCHT = '[DokumentverwaltungPage] Aktuelles Dokument wurde gelöscht';
export const AKTUELLES_DOKUMENT_WURDE_AKTIVIERT = '[DokumentverwaltungPage] Aktuelles Dokument wurde aktiviert';
export const AKTUELLES_DOKUMENT_WURDE_DEAKTIVIERT = '[DokumentverwaltungPage] Aktuelles Dokument wurde deaktiviert';
export const AKTUELLES_DOKUMENT_AENDERN = '[DokumentverwaltungPage] Aktuelles Dokument wurde in der Ansicht geändert';
export const NICHT_ANZUZEIGENDE_ROLLEN_BENUTZER_SETZEN = '[DokumentverwaltungPage] Benutzer die aus der Auswahl entfernt werden sollen setzen';
export const ROLLEN_BENUTZER_AKTIVIERT = '[DokumentverwaltungPage] Benutzer aktiviert';
export const ROLLEN_BENUTZER_DEAKTIVIERT = '[DokumentverwaltungPage] Benutzer deaktiviert';

export const AKTUELLES_DOKUMENT_TYPEN_SETZEN = '[DokumentverwaltungPage] Aktuelles Dokument Typen setzen';



// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// UI
export class NeuesDokumentAction implements Action {
    readonly type = NEUES_DOKUMENT;

    constructor(public dokument: Dokument) {
    }
}

export class DokumentAbbrechenAction implements Action {
    readonly type = DOKUMENT_ABBRECHEN;

    constructor() {
    }
}

export class AktuellesDokumentSetzenAction implements Action {
    readonly type = AKTUELLES_DOKUMENT_GESETZT;

    constructor(public dokument?: Dokument) {
    }
}

export class AktuellesDokumentWurdeGeloescht implements Action {
    readonly type = AKTUELLES_DOKUMENT_WURDE_GELOESCHT;

    constructor() {
    }
}

export class NichtAnzuzeigendeRollenBenutzerSetzenAction implements Action {
    readonly type = NICHT_ANZUZEIGENDE_ROLLEN_BENUTZER_SETZEN;

    constructor(public nichtAnzuzeigendeBenutzer: Array<any>) {
    }
}

export class RollenBenutzerAktiviertAction implements Action {
    readonly type = ROLLEN_BENUTZER_AKTIVIERT;

    constructor(public rolleBenutzerCheckboxWrapper: RolleBenutzerCheckboxWrapper) {
    }
}

export class RollenBenutzerDeaktiviertAction implements Action {
    readonly type = ROLLEN_BENUTZER_DEAKTIVIERT;

    constructor(public rolleBenutzerCheckboxWrapper: RolleBenutzerCheckboxWrapper) {
    }
}

export class AktuellesDokumentAendernAction implements Action {
    readonly type = AKTUELLES_DOKUMENT_AENDERN;

    constructor(public dokument?: Dokument) {
    }
}

export class AktuellesDokumentTypenSetzenAction implements Action {
    readonly type = AKTUELLES_DOKUMENT_TYPEN_SETZEN;
    constructor(public payload: Array<string>) {
    }
}


export type Actions =
    NeuesDokumentAction
    | DokumentAbbrechenAction
    | AktuellesDokumentSetzenAction
    | AktuellesDokumentWurdeGeloescht
    | AktuellesDokumentAendernAction
    | PageStateResetAction
    | NichtAnzuzeigendeRollenBenutzerSetzenAction
    | RollenBenutzerAktiviertAction
    | RollenBenutzerDeaktiviertAction
    | AktuellesDokumentTypenSetzenAction
    ;
